import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import LoaderAnimation from "../animations/LoaderAnimation.json";
import backgroundAnimation from "../animations/Animation5.json";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="main-page">
      <div className="background-animation">
        <Player autoplay loop src={backgroundAnimation} />
      </div>

      <div className="loader-animation">
        <Player autoplay loop src={LoaderAnimation} />
      </div>
    </div>
  );
};

export default Loader;